import React from "react"
import { twMerge } from "tailwind-merge"

const EnvBanner = () => {
  const isLocalhost = window.location.href.slice(0, 16) === "http://localhost"
  const isDev = import.meta.env.DEV || String(import.meta.env.VITE_ENVIRONMENT_TYPE).replace(/"/g, "") === "develop"
  const network = (import.meta.env.VITE_SOLANA_NETWORK as string) || "devnet"
  const isMainnet = network === "mainnet"

  if (!isDev) return <></>

  return (
    <>
      <div
        className={twMerge(
          "fixed left-[-100px] top-10 z-[100] flex w-[320px] rotate-[-45deg] justify-center border-2 border-l-0 border-black py-2",
          isLocalhost ? "bg-[#f59122]" : "bg-[#f59122]",
        )}
      >
        <span className="text-black">{isLocalhost ? "localhost" : "STAGE"}</span>
      </div>
      <div
        className={twMerge(
          "fixed right-3 top-3 z-[100] rounded-full px-3 py-1 text-xs font-bold shadow-lg",
          isMainnet
            ? "bg-[#D64853] text-white"
            : "bg-[#00b078] text-black",
        )}
      >
        {isMainnet ? "MAINNET" : "DEVNET"}
      </div>
    </>
  )
}

export default EnvBanner
